




















































// vue
import {
    computed,
    defineComponent,
    onMounted,
    ref,
} from '@vue/composition-api';

// hooks
import { useStore } from '@/store';

// services
import { useService } from '@/vue3/api/services';

// models
import { Project } from '@/vue3/api/models';

// primevue
import Listbox from 'primevue/listbox';
import ProgressSpinner from 'primevue/progressspinner';
import Button from 'primevue/button';
import EditorDropdown from '@/vue3/components/editor/EditorDropdown.vue';

export default defineComponent({
    components: {
        Listbox,
        ProgressSpinner,
        Button,
        EditorDropdown,
    },
    props: {
        geoRecord: {
            type: Object,
            default: () => {},
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any) {
        // hooks
        const { getProjects, createProject, updateProject } = useService();
        const { getters } = useStore();

        // reactive
        const projects = ref<Project[]>([]);
        const selectedProject = ref<Project>({} as Project);
        const newProjectName = ref('');

        // computed
        const projectSelected = computed(() => {
            if (projects.value) {
                return projects.value.find(
                    (project) => project.id == props.geoRecord.projectId,
                );
            }
            return null;
        });

        // methods
        const refreshProjects = async () => {
            projects.value = await getProjects();
            if (projects.value !== null) {
                projects.value = [
                    {
                        id: 0,
                        name: 'None',
                        organizationId: getters.currentOrganization.id,
                    },
                    ...projects.value,
                ];
            }

            projects.value = projects.value.filter(
                (project, index, self) =>
                    index === self.findIndex((t) => t.name === project.name),
            );

            sortProjectsByName(projects.value);
        };

        const sortProjectsByName = (projects: any) => {
            projects.sort((a: any, b: any) => {
                if (a.name === 'None') return -1;
                if (b.name === 'None') return 1;

                const numA = parseInt(a.name);
                const numB = parseInt(b.name);

                return !isNaN(numA) && !isNaN(numB)
                    ? numA - numB
                    : !isNaN(numA)
                    ? 1
                    : !isNaN(numB)
                    ? -1
                    : a.name.localeCompare(b.name);
            });
        };
        const saveProject = async (proj: Project, newProject: boolean) => {
            if (newProject) {
                proj.organizationId = getters.currentOrganization.id;
                selectedProject.value.name = newProjectName.value;
                selectedProject.value = await createProject(proj);
                newProjectName.value = '';
            } else {
                selectedProject.value = await updateProject(proj);
            }
            refreshProjects();
        };

        // lifecycle
        onMounted(async () => {
            refreshProjects();
        });

        return {
            projects,
            selectedProject,
            saveProject,
            newProjectName,
            projectSelected,
        };
    },
});
